import { type CSSObject } from '@emotion/react';
import { useTheme } from '../../../theme';

type UseStylesReturnType = Record<'container', CSSObject>;

export const useOptionButtonContainerStyles = (): UseStylesReturnType => {
  const theme = useTheme();
  return {
    container: {
      fontFamily: 'inherit',
      display: 'flex',
      padding: theme.spacing(3),
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'initial',
      gap: theme.spacing(2),
      borderRadius: theme.shape.radius8,
      border: `1px solid ${theme.button.outline.default}`,
      cursor: 'pointer',
      minHeight: 112,
      flex: '1 0 0',
      '&:hover': {
        borderColor: theme.button.outline.hover,
      },
      '&:active, &:focus': {
        borderColor: theme.button.outline.pressed,
        outline: `2.5px solid ${theme.button.focused.default}`,
      },
    },
  };
};
